import { useState } from 'react';
import styled from 'styled-components';
import {
  ButtonIcon,
  cssColorValue,
  IconDownload,
  spacer24,
  spacer8,
  Tooltip,
  TooltipTrigger,
  VisuallyHidden,
} from '@spotify-internal/encore-web';
import { IconProps } from '@spotify-internal/encore-web/types/src/core/components/Icon';

const StyledButtonIcon = styled(ButtonIcon)`
  margin-right: ${spacer8};
  cursor: pointer;
`;

const DownloadIcon = styled(IconDownload)`
  width: ${spacer24};
  height: auto;
  padding-top: 6px;
`;

const IconContainer = styled.div<{
  hasHoverBackground: boolean;
}>`
  width: 36px;
  height: 36px;
  border-radius: 50%;

  &:hover {
    background: ${props =>
      props.hasHoverBackground
        ? cssColorValue('backgroundTintedBase')
        : 'none'};
  }
`;

interface CopyDownloadIconProps extends IconProps {
  disabled: boolean;
  hasHoverBackground: boolean;
  hoverText: string;
  screenReaderText: string;
  handleClick: () => void;
}

export const StyledDownloadIcon = ({
  disabled,
  hasHoverBackground,
  hoverText,
  screenReaderText,
  handleClick,
}: CopyDownloadIconProps) => {
  const [showTooltip, toggleTooltip] = useState<boolean>(false);

  return (
    <StyledButtonIcon disabled={disabled} onClick={handleClick}>
      <TooltipTrigger
        overlay={showTooltip && <Tooltip>{hoverText}</Tooltip>}
        onShow={() => toggleTooltip(true)}
        onHide={() => toggleTooltip(false)}
        placement={TooltipTrigger.top}
      >
        <IconContainer
          hasHoverBackground={hasHoverBackground}
          aria-label="Download"
        >
          <DownloadIcon semanticColor="textSubdued" />
          <VisuallyHidden>{screenReaderText}</VisuallyHidden>
        </IconContainer>
      </TooltipTrigger>
    </StyledButtonIcon>
  );
};
